// extracted by mini-css-extract-plugin
module.exports = {"cart-items":"Cart_cart-items__NJlco","total":"Cart_total__3_vRP","actions":"Cart_actions__2XA1d","button--alt":"Cart_button--alt__2uDwN","button":"Cart_button__QGuma"};